import auth from '@/services/auth'

const event = {
  create: async function (template) {
    var d = {}
    if (template) d.template = template
    try {
      const resp = await auth.sendWithToken({
        method: 'post',
        url: '/v1/events',
        data: d
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  studio: async function (id) {
    try {
      const resp = await auth.sendWithToken({
        method: 'get',
        url: '/v1/events/' + id + '/studio'
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  startWebRTCServerToClient: async function (clientID, id) {
    try {
      // Send
      const resp = await auth._sendEvent({
        method: 'post',
        url: '/v1/webrtc/server-to-client',
        data: {
          client_id: clientID,
          id: id
        }
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  update: async function (id, name, description, orientation) {
    // Get data
    const d = {}
    if (description) d.description = description
    if (name) d.name = name
    if (orientation) d.orientation = orientation

    // Send
    try {
      const resp = await auth.sendWithToken({
        method: 'patch',
        url: '/v1/events/' + id,
        data: d
      })
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  director: async function () {
    try {
      const resp = await auth._sendEvent({
        method: 'get',
        url: '/v1/welcome/director'
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  updateOverlays: async function (overlays) {
    try {
      const resp = await auth._sendEvent({
        method: 'patch',
        url: '/v1/overlays',
        data: {
          overlays: overlays
        }
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  applyToLive: async function () {
    try {
      const resp = await auth._sendEvent({
        method: 'get',
        url: '/v1/live/apply'
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  startLive: async function () {
    try {
      const resp = await auth._sendEvent({
        method: 'get',
        url: '/v1/live/start'
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  stopLive: async function () {
    try {
      const resp = await auth._sendEvent({
        method: 'get',
        url: '/v1/live/stop'
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  applyToPreview: async function (selected) {
    try {
      const resp = await auth._sendEvent({
        method: 'patch',
        url: '/v1/preview/apply',
        data: selected
      })
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  updateVolume: async function (id, value) {
    try {
      const resp = await auth._sendEvent({
        method: 'patch',
        url: '/v1/inputs/' + id + '/volume',
        data: {
          value: parseInt(value, 0)
        }
      })
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  createText: async function (template) {
    try {
      const resp = await auth._sendEvent({
        method: 'post',
        url: '/v1/texts/' + template
      })
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  updateText: async function (id, text) {
    try {
      // Remove id from data
      const data = Object.assign({}, text)
      delete data.id

      // Send
      const resp = await auth._sendEvent({
        method: 'patch',
        url: '/v1/texts/' + id,
        data: data
      })
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  removeText: async function (id) {
    try {
      const resp = await auth._sendEvent({
        method: 'delete',
        url: '/v1/texts/' + id
      })
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  updateAutomix: async function (blacklist, enabled, intervalMax, intervalMin) {
    // Get data
    const d = {}
    if (blacklist) d.blacklist = blacklist
    if (typeof enabled !== 'undefined' && enabled !== null) d.enabled = enabled
    if (intervalMax) d.interval_max = intervalMax
    if (intervalMin) d.interval_min = intervalMin

    // Send
    try {
      const resp = await auth._sendEvent({
        method: 'patch',
        url: '/v1/automix',
        data: d
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  sendMessage: async function (message, to) {
    try {
      const resp = await auth._sendEvent({
        method: 'post',
        url: '/v1/messages',
        data: {
          message: message,
          to: to
        }
      })
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  },
  toggleAudioLock: async function (enabled) {
    try {
      const resp = await auth._sendEvent({
        method: enabled ? 'post' : 'delete',
        url: '/v1/audio-lock'
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  files: async function (id) {
    try {
      const resp = await auth.sendWithToken({
        method: 'get',
        url: '/v1/events/' + id + '/files'
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  },
  createInvitation: async function (eventID, contributionID, email) {
    try {
      const resp = await auth.sendWithToken({
        method: 'post',
        url: '/v1/events/' + eventID + '/invitations',
        data: {
          contributions: [{ id: contributionID }],
          emails: [email]
        }
      })
      return resp.data
    } catch (err) {
      return Promise.reject(err)
    }
  }
}

export default event
